module.exports = __webpack_public_path__ + "static/media/italic.72df54e2.svg";